const queryOptions = [
    {
      name: "name",
      displayName: "Iskola neve",
      type: "schoolName",
      used: false,
      value: "",
    },
    {
      name: "createdAt",
      displayName: "Létrehozás dátuma",
      type: "date",
      used: false,
      value: "",
    },
  ];
  
  export default queryOptions;
  